import { render, staticRenderFns } from "./index.vue?vue&type=template&id=511ea20c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=511ea20c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ea20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511ea20c')) {
      api.createRecord('511ea20c', component.options)
    } else {
      api.reload('511ea20c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=511ea20c&scoped=true", function () {
      api.rerender('511ea20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detection/orders/index.vue"
export default component.exports